<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from '../../i18n'

defineProps({ permissionNames: { type: Array, required: true } })
const emit = defineEmits(['confirm', 'cancel'])
const panel = ref(null)
const { t } = useI18n()
let previousFocus = null

function cancel() { emit('cancel') }
function keydown(event) {
  if (event.key === 'Escape') { event.preventDefault(); cancel(); return }
  if (event.key !== 'Tab' || !panel.value) return
  const focusable = [...panel.value.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"])')]
    .filter((item) => !item.disabled)
  if (!focusable.length) return
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
}

onMounted(async () => {
  previousFocus = document.activeElement
  document.body.classList.add('drawer-open')
  await nextTick()
  panel.value?.querySelector('[data-autofocus]')?.focus()
})
onBeforeUnmount(() => {
  document.body.classList.remove('drawer-open')
  previousFocus?.focus?.()
})
</script>

<template>
  <Teleport to="body">
    <div class="risk-confirmation-layer" @keydown="keydown">
      <button class="risk-confirmation-backdrop" type="button" :aria-label="t('close')" @click="cancel"></button>
      <section ref="panel" class="risk-confirmation-dialog" role="dialog" aria-modal="true"
        aria-labelledby="risk-confirmation-title" aria-describedby="risk-confirmation-description">
        <header><p class="eyebrow">{{ t('elevatedAccess') }}</p><h2 id="risk-confirmation-title">{{ t('highRiskTitle') }}</h2></header>
        <p id="risk-confirmation-description">{{ t('highRiskHint') }}</p>
        <ul><li v-for="name in permissionNames" :key="name">{{ name }}</li></ul>
        <footer><button data-autofocus class="button button-secondary" type="button" @click="cancel">{{ t('returnAction') }}</button><button class="button button-danger" type="button" @click="emit('confirm')">{{ t('confirmAndSave') }}</button></footer>
      </section>
    </div>
  </Teleport>
</template>
